import React, { useRef, useCallback, useEffect } from 'react';
import { ConfirmDialog, confirmDialog } from 'primereact/confirmdialog';
import { Toast } from 'primereact/toast';

export const ConfirmationDialog = ({
    message = 'Are you sure?',
    header = 'Delete Confirmation',
    icon = 'pi pi-info-circle',
    acceptLabel = 'Yes',
    rejectLabel = 'No',
    acceptClassName = 'p-button-success p-button-outlined',
    rejectClassName = 'p-button-danger  p-button-outlined',
    onAccept,
    onReject,
    showToast = true, // Optional prop to enable/disable toast messages
}) => {
    const toastRef = useRef(null);

    const handleAccept = useCallback(() => {
        if (showToast && toastRef.current) {
            toastRef.current.show({
                severity: 'success',
                summary: 'Confirmed',
                detail: 'Action has been confirmed',
                life: 3000,
            });
        }
        if (onAccept) onAccept(); // Trigger onAccept callback
    }, [showToast, onAccept]);

    const handleReject = useCallback(() => {
        if (showToast && toastRef.current) {
            toastRef.current.show({
                severity: 'warn',
                summary: 'Rejected',
                detail: 'Action has been rejected',
                life: 3000,
            });
        }
        if (onReject) onReject(); // Trigger onReject callback
    }, [showToast, onReject]);

    const showDialog = useCallback(() => {
        confirmDialog({
            message,
            header,
            icon,
            acceptLabel,
            rejectLabel,
            acceptClassName,
            rejectClassName,
            accept: handleAccept,
            reject: handleReject,
        });
    }, [message, header, icon, acceptLabel, rejectLabel, acceptClassName, rejectClassName, handleAccept, handleReject]);

    useEffect(() => {
        showDialog();
    }, [showDialog]);

    return (
        <>
            <Toast ref={toastRef} />
            <ConfirmDialog style={{ width: '400px' }} closable={ false } closeOnEscape={ false } draggable={ false } />
        </>
    );
};